export default __webpack_public_path__ + "static/media/tv.2196860a.svg";